module.exports = __webpack_public_path__ + "img/511.5155aa2a.png";